export const citation = {
  english: {
    citationLabel: 'Citation Guide',
    citationParagraphOne:
      'Any use of the content on this website should properly acknowledge, cite, and be attributed to the original author(s) and source of the material. Citation guidelines should be followed in accordance with academic standards and the specific instructions provided below:',
    citationParagraphTwo:
      'Chicago format: “Title of Web Page.” The Guru Granth Sahib Project. Sikh Research Institute, publication month day, year. URL.',
    citationParagraphThree:
      'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib. Sikh Research Institute, September 1, 2020.',
    link1:
    'https://gurugranthsahib.io/bani/AKV',  

    paragraph2:
    'MLA format: “Title of Web Page.” The Guru Granth Sahib Project, Day Month. Year of Publication, URL, Accessed Date of Access[.]',
    paragraph2_1:
    'Sample: “Bani Asa Ki Var in the English Language.” The Guru Granth Sahib Project, 1 Sept. 2020,',
    link2:
    'https://gurugranthsahib.io/bani/AKV',
    paragraph2_2:
    'Accessed 7 July 2023.',

    paragraph3:
    'APA format: Publishing Organization. (Year, Month, Day of Publication). Title of Webpage. Website Name. Retrieved Month Day, Year, from URL.',
    paragraph3_1:
    'Sample:  Sikh Research Institute (2020, December 1). Bani Asa Ki Var in the English Language. The Guru Granth Sahib Project. Retrieved October 7, 2023, from',
    link3:
    'https://gurugranthsahib.io/bani/AKV',

  },
  panjabi: {
    citationLabel: 'ਹਵਾਲੇ ਦੇਣ ਸਬੰਧੀ ਦਿਸ਼ਾ-ਨਿਰਦੇਸ਼',
    citationParagraphOne:
    'ਇਸ ਵੈਬਸਾਈਟ ਉਪਰ ਮੌਜੂਦ ਮੂਲ ਸਮੱਗਰੀ ਦੀ ਕਿਸੇ ਵੀ ਪ੍ਰਕਾਰ ਦੀ ਵਰਤੋਂ ਕਰਨ ਵੇਲੇ ਮੂਲ ਲੇਖਕ ਅਤੇ ਸਮੱਗਰੀ ਸਰੋਤ ਦੇ ਪੂਰੇ ਹਵਾਲੇ ਨਾਲ ਸਵੀਕਾਰ ਕਰਨਾ, ਉਸ ਦਾ ਹਵਾਲਾ ਅਤੇ ਇਸ ਕਾਰਜ ਦਾ ਉਸ ਨੂੰ ਸਿਹਰਾ ਦਿੱਤਾ ਜਾਣਾ ਚਾਹੀਦਾ ਹੈ। ਹਵਾਲਾ ਦੇਣ ਵੇਲੇ ਅਕਾਦਮਿਕ ਮਾਪਦੰਡਾਂ ਅਤੇ ਨਿਮਨਲਿਖਤ ਨਿਰਦੇਸ਼ਾਂ ਦੀ ਪਾਲਣਾ ਕੀਤੀ ਜਾਣੀ ਚਾਹੀਦੀ ਹੈ:',
    citationParagraphTwo:
    'ਸ਼ਿਕਾਗੋ ਫਾਰਮੈਟ: “ਵੈਬਪੇਜ ਦਾ ਸਿਰਲੇਖ” ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ. ਸਿਖ ਰਿਸਰਚ ਇੰਸਟੀਟਿਊਟ, ਪ੍ਰਕਾਸ਼ਨ ਮਹੀਨਾ ਦਿਨ. ਸਾਲ. ਯੂ ਆਰ ਐਲ.',
    citationParagraphThree:
    'ਨਮੂਨਾ: “ਬਾਣੀ ਆਸਾ ਕੀ ਵਾਰ ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਚ.” ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ. ਸਿਖ ਰਿਸਰਚ ਇੰਸਟੀਟਿਊਟ, ਸਤੰਬਰ 1, ੨੦੨੦.',
    link1:
    'https://gurugranthsahib.io/bani/AKV',  

    paragraph2:
    'ਐਮਐਲਏ ਫਾਰਮੈਟ: “ਵੈਬਪੇਜ ਦਾ ਸਿਰਲੇਖ.” ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ, ਪ੍ਰਕਾਸ਼ਨ ਦਾ ਦਿਨ ਮਹੀਨਾ. ਸਾਲ, ਯੂ ਆਰ ਐਲ, ਪਹੁੰਚ ਕਰਨ ਦੀ ਮਿਤੀ[.]',
    paragraph2_1:
    'ਨਮੂਨਾ: “ਬਾਣੀ ਆਸਾ ਕੀ ਵਾਰ ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਚ.” ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ, 1 ਸਤੰਬਰ. ੨੦੨੦,',
    link2:
    'https://gurugranthsahib.io/bani/AKV',
    paragraph2_2:
    'ਲਿਆ/ਪ੍ਰਾਪਤ ਕੀਤਾ ਗਿਆ 7 ਜੁਲਾਈ ੨੦੨੦.',

    paragraph3:
    'ਏਪੀਏ ਫਾਰਮੈਟ: ਪ੍ਰਕਾਸ਼ਨ ਸੰਸਥਾ. (ਪ੍ਰਕਾਸ਼ਨ ਦਾ ਸਾਲ, ਮਹੀਨਾ, ਦਿਨ). ਵੈਬਪੇਜ ਦਾ ਸਿਰਲੇਖ. ਵੈਬਸਾਈਟ ਦਾ ਨਾਮ. ਪ੍ਰਾਪਤ ਕੀਤਾ ਮਹੀਨਾ ਦਿਨ, ਸਾਲ, ਯੂ ਆਰ ਐਲ.',
    paragraph3_1:
    'ਨਮੂਨਾ: ਸਿਖ ਰਿਸਰਚ ਇੰਸਟੀਟਿਊਟ (੨੦੨੦, ਦਸੰਬਰ ੧). ਬਾਣੀ ਆਸਾ ਕੀ ਵਾਰ ਪੰਜਾਬੀ ਭਾਸ਼ਾ ਵਿਚ. ਗੁਰੂ ਗ੍ਰੰਥ ਸਾਹਿਬ ਪ੍ਰੌਜੈਕਟ. ਪ੍ਰਾਪਤ ਕੀਤਾ ਅਕਤੂਬਰ 7, ੨੦੨੦',
    link3:
    'https://gurugranthsahib.io/bani/AKV',
  },
};
